import { createActionGroup, emptyProps } from '@ngrx/store';

export const UIActions = createActionGroup({
  source: 'UI',
  events: {
    'Request Sent': emptyProps(),
    'Request Completed': emptyProps(),
  },
});